import { render, staticRenderFns, recyclableRender, components } from "./yinpin.vue?vue&type=template&id=3ad419e6&"
var renderjs
import script from "./yinpin.vue?vue&type=script&lang=js&"
export * from "./yinpin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/yinpin/yinpin.vue"
export default component.exports